import { render } from "./Home.vue?vue&type=template&id=6d720fe5"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Home/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d720fe5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d720fe5', __exports__)) {
    api.reload('6d720fe5', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=6d720fe5", () => {
    api.rerender('6d720fe5', render)
  })

}


export default __exports__